export const formatDate = dateString => {
  const parsedDate = new Date(dateString?.replace('Z', ''));

  return parsedDate.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour12: true,
  });
};
export const formatDateReceipt = dateString => {
  const parsedDate = new Date(dateString?.replace('Z', ''));

  return parsedDate.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour12: true,
  });
};
export const formatDateWithTime = dateString => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
    // second: '2-digit',
  });
};

export const formatDateNew = dateString => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour12: true,
    // hour: 'numeric',
    // minute: '2-digit',
    // second: '2-digit',
  });
};

export const formatDateNewWithTime = dateString => {
  const parsedDate = new Date(dateString);

  return parsedDate.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
    // second: '2-digit',
  });
};

export const removeZoneFromDate = dateString => {
  return new Date(dateString.replace('Z', ''));
};

export const localeDateStartDate = (dateString) => {
  if (!dateString) return null;

  const startDate = new Date(dateString);

  if (isNaN(startDate.getTime())) {
    return null;
  }

  startDate.setHours(0, 0, 0, 0);

  return startDate.toISOString();
};

export const localeDateEndDate = (dateString) => {
  if (!dateString) return null;

  const endOfToday = new Date(dateString);

  if (isNaN(endOfToday.getTime())) {
    return null;
  }

  endOfToday.setHours(23, 59, 59, 999);

  return endOfToday.toISOString();
};


